// eslint-disable-next-line wandb/no-deprecated-imports
import {Dropdown} from 'semantic-ui-react';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

export const PanelArtifactHeaderContent = styled.div`
  height: 3.4em;
  display: flex;
  align-items: center;
`;
PanelArtifactHeaderContent.displayName = 'S.PanelArtifactHeaderContent';

export const PanelArtifactHeaderTitle = styled.div`
  font-size: 1.5em;
  font-weight: 600;
  padding-left: 0.5em;
`;
PanelArtifactHeaderTitle.displayName = 'S.PanelArtifactHeaderTitle';

export const TriggerContainer = styled.div`
  margin-left: auto;
  margin-right: 16px;
`;
TriggerContainer.displayName = 'S.TriggerContainer';

export const CollectionDropdown = styled(Dropdown)`
  margin-left: 1em !important;
  font-size: 16px !important;
`;
CollectionDropdown.displayName = 'S.CollectionDropdown';

export const PanelWrapper = styled.div`
  height: 100%;
  width: 100%;
  flex: 1 1 auto;
  overflow: auto;
  padding: 0px;
  padding-bottom: 60px;
  background-color: #fff;
`;
PanelWrapper.displayName = 'S.PanelWrapper';

export const OverviewPanel = styled.div`
  padding-left: 0.9em;
  padding-right: 0.9em;
  padding-top: 0.8em;
  margin-bottom: 1em;
`;
OverviewPanel.displayName = 'S.OverviewPanel';

export const BlankPageWrapper = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: scroll;
`;
BlankPageWrapper.displayName = 'S.BlankPageWrapper';

export const ArtifactCollectionMain = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: #f9f9f9;
  display: flex;
  flex-direction: column;
  padding-top: 10px;
`;
ArtifactCollectionMain.displayName = 'S.ArtifactCollectionMain';

export const VersionsPanelSectionHeaderTitle = styled.div`
  display: flex;
  align-items: center;
  font-size: 1.2em;
  font-weight: 500;
  .ui.button {
    margin-left: 15px;
  }
`;
VersionsPanelSectionHeaderTitle.displayName =
  'S.VersionsPanelSectionHeaderTitle';

export const VersionsPanelSectionHeader = styled.div`
  position: sticky;
  top: 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
VersionsPanelSectionHeader.displayName = 'S.VersionsPanelSectionHeader';
